import React, { useState, useRef } from 'react';import '../../common/SubNavbar.css'
import '../../common/CommonText.css'
import ArchivePopup from '../../Popup/ArchivePopup/ArchivePopup';
import PropTypes from 'prop-types'; // Add this import at the top


  // const ArchiveSelectedItem = ({ selectedItems, items, onArchiveSelected }) => {
  //   const { isAllArchived, isAllUnarchived, isMixed } = React.useMemo(() => {
  //     if (selectedItems.length === 0) {
  //       return { isAllArchived: false, isAllUnarchived: false, isMixed: false };
  //     }
  
  //     let archivedCount = 0;
  //     let unarchivedCount = 0;
  
  //     selectedItems.forEach((id) => {
  //       const item = items.find((i) => i.id === id);
  //       if (item) {
  //         if (item.is_archived === true) {
  //           archivedCount++;
  //         } else if (item.is_archived === false) {
  //           unarchivedCount++;
  //         }
  //       }
  //     });
  
  //     return {
  //       isAllArchived: archivedCount === selectedItems.length && archivedCount > 0,
  //       isAllUnarchived: unarchivedCount === selectedItems.length && unarchivedCount > 0,
  //       isMixed: archivedCount > 0 && unarchivedCount > 0,
  //     };
  //   }, [selectedItems, items]);
  
  //   const isClickable = selectedItems.length > 0 && !isMixed;
  
  //   const renderIcon = () => {
  //     if (isAllArchived) {
  //       return (
  //         <svg className="unarchive-selected navbar-download-icon" width="28" height="28" viewBox="0 0 28 28" fill="none">
  //           <path d="M0 28V4.35556L3.57778 0H24.4222L28 4.35556V28H0ZM3.73333 4.66667H24.2667L22.9444 3.11111H5.05556L3.73333 4.66667Z" fill="#094C80"/>
  //           <path d="M12.5 23L15.5 23L15.5 16.5L18 19L20 17L14 11L8 17L10 19L12.5 16.5L12.5 23Z" fill="white"/>
  //         </svg>
  //       );
  //     }
  //     return (
  //       <svg className="archive-selected navbar-download-icon" width="28" height="28" viewBox="0 0 28 28" fill="none">
  //         <path d="M14 23.3333L20.2222 17.1111L18.0444 14.9333L15.5556 17.4222V10.8889H12.4444V17.4222L9.95555 14.9333L7.77778 17.1111L14 23.3333ZM0 28V4.35556L3.57778 0H24.4222L28 4.35556V28H0ZM3.73333 4.66667H24.2667L22.9444 3.11111H5.05556L3.73333 4.66667Z" fill="#DFA226"/>
  //       </svg>
  //     );
  //   };
  
  //   return (
  //     <div 
  //       onClick={() => isClickable && onArchiveSelected('group_archive_trigger')}
  //       style={{ 
  //         cursor: isClickable ? 'pointer' : 'not-allowed', 
  //         opacity: isClickable ? 1 : 0.4 
  //       }}
  //     >
  //       {renderIcon()}
  //     </div>
  //   );
  // };
  
  // ArchiveSelectedItem.propTypes = {
  //   selectedItems: PropTypes.arrayOf(PropTypes.string).isRequired,
  //   items: PropTypes.arrayOf(
  //     PropTypes.shape({
  //       id: PropTypes.string,
  //       is_archived: PropTypes.bool
  //     })
  //   ).isRequired,
  //   onArchiveSelected: PropTypes.func.isRequired
  // };
  
  // export default ArchiveSelectedItem;


  const ArchiveSelectedItem = ({ selectedItems, items, onArchiveSelected }) => {
    const [showPopup, setShowPopup] = useState(false);
    const [actionType, setActionType] = useState('');
    const [popupPosition, setPopupPosition] = useState({ top: 0, left: 0 });
    const iconRef = useRef(null);
  
    const { isAllArchived, isAllUnarchived, isMixed } = React.useMemo(() => {
      if (selectedItems.length === 0) {
        return { isAllArchived: false, isAllUnarchived: false, isMixed: false };
      }
  
      let archivedCount = 0;
      let unarchivedCount = 0;
  
      selectedItems.forEach((id) => {
        const item = items.find((i) => i.id === id);
        if (item) {
          if (item.is_archived === true) {
            archivedCount++;
          } else if (item.is_archived === false) {
            unarchivedCount++;
          }
        }
      });
  
      return {
        isAllArchived: archivedCount === selectedItems.length && archivedCount > 0,
        isAllUnarchived: unarchivedCount === selectedItems.length && unarchivedCount > 0,
        isMixed: archivedCount > 0 && unarchivedCount > 0,
      };
    }, [selectedItems, items]);
  
    const isClickable = selectedItems.length > 0 && !isMixed;
  
    const handleClick = (event) => {
      if (!isClickable) return;
  
      const iconRect = iconRef.current.getBoundingClientRect();
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;
      const scrollLeft = window.pageXOffset || document.documentElement.scrollLeft;
  
      // Position the popup relative to the clicked icon
      setPopupPosition({
        top: iconRect.bottom + scrollTop,
        left: iconRect.left + scrollLeft - 150, // Adjust the left position to center the popup
      });
  
      setActionType(isAllArchived ? 'unarchive' : 'archive');
      setShowPopup(true);
    };
  
    const handleConfirm = () => {
      onArchiveSelected(actionType);
      setShowPopup(false);
    };
  
    const handleCancel = () => {
      setShowPopup(false);
    };
  
    const selectedCount = selectedItems.length;
  
    return (
      <div className="archive-selected-container" style={{ position: 'relative' }}>
        <div
          ref={iconRef}
          onClick={handleClick}
          style={{ cursor: isClickable ? 'pointer' : 'not-allowed', opacity: isClickable ? 1 : 0.4 }}
        >
          {isAllArchived ? (
            <svg className="unarchive-selected navbar-download-icon" width="28" height="28" viewBox="0 0 28 28" fill="none">
              <path d="M0 28V4.35556L3.57778 0H24.4222L28 4.35556V28H0ZM3.73333 4.66667H24.2667L22.9444 3.11111H5.05556L3.73333 4.66667Z" fill="#094C80"/>
              <path d="M12.5 23L15.5 23L15.5 16.5L18 19L20 17L14 11L8 17L10 19L12.5 16.5L12.5 23Z" fill="white"/>
            </svg>
          ) : (
            <svg className="archive-selected navbar-download-icon" width="28" height="28" viewBox="0 0 28 28" fill="none">
              <path d="M14 23.3333L20.2222 17.1111L18.0444 14.9333L15.5556 17.4222V10.8889H12.4444V17.4222L9.95555 14.9333L7.77778 17.1111L14 23.3333ZM0 28V4.35556L3.57778 0H24.4222L28 4.35556V28H0ZM3.73333 4.66667H24.2667L22.9444 3.11111H5.05556L3.73333 4.66667Z" fill="#DFA226"/>
            </svg>
          )}
        </div>
  
        {showPopup && (
          <div style={{ 
            position: 'fixed',
            top: `${popupPosition.top}px`,
            left: `${popupPosition.left}px`,
            zIndex: 1000
          }}>
            <ArchivePopup
              isOpen={showPopup}
              archivename={`${selectedCount} selected item${selectedCount > 1 ? 's' : ''}`}
              onSave={handleConfirm}
              onClose={handleCancel}
              isArchived={isAllArchived}
            />
          </div>
        )}
      </div>
    );
  };
  
  ArchiveSelectedItem.propTypes = {
    selectedItems: PropTypes.arrayOf(PropTypes.string).isRequired,
    items: PropTypes.arrayOf(
      PropTypes.shape({
        id: PropTypes.string,
        is_archived: PropTypes.bool
      })
    ).isRequired,
    onArchiveSelected: PropTypes.func.isRequired
  };
  
  export default ArchiveSelectedItem;
  